import type {Mapper} from 'framework';
import type {Workout, WorkoutExercise, WorkoutSet} from '../../domain/workout';
import type {WorkoutDto} from '../dto/workout.dto';

export class WorkoutDtoToWorkoutMapper implements Mapper<WorkoutDto, Workout> {
  transform(dto: WorkoutDto): Workout {
    return {
      id: dto.id,
      templateId: dto.templateId,
      name: dto.name,
      status: dto.status,
      startedAt: dto.startedAt !== null ? String(dto.startedAt) : null,
      finishedAt: dto.finishedAt !== null ? String(dto.finishedAt) : null,
      durationSeconds: dto.durationSeconds,
      notes: dto.notes,
      totalVolumeKg: dto.totalVolumeKg,
      totalSets: dto.totalSets,
      exercises: dto.exercises.map(
        (exercise): WorkoutExercise => ({
          id: exercise.id,
          exerciseId: exercise.exerciseId,
          name: exercise.name,
          orderIndex: exercise.orderIndex,
          groupId: exercise.groupId,
          restSeconds: exercise.restSeconds,
          notes: exercise.notes,
          sets: exercise.sets.map(
            (set): WorkoutSet => ({
              id: set.id,
              setNumber: set.setNumber,
              weightKg: set.weightKg,
              reps: set.reps,
              rpe: set.rpe,
              isWarmup: set.isWarmup,
              isDropset: set.isDropset,
              isFailure: set.isFailure,
              notes: set.notes,
              startedAt: set.startedAt !== null ? String(set.startedAt) : null,
              completedAt: set.completedAt !== null ? String(set.completedAt) : null,
            }),
          ),
        }),
      ),
      createdAt: String(dto.createdAt),
      updatedAt: String(dto.updatedAt),
    };
  }
}
